import type { ConversationStatus } from '@elevenlabs/react';

import strings from '../../../localization';

interface ConversationUiState {
  emptyStateDescription: string;
  inputPlaceholder: string;
  statusLabel: string;
  voiceActionLabel: string;
  voiceStatusLabel: string;
}

interface IGetConversationUiState {
  isConnected: boolean;
  isSpeaking: boolean;
  isTransitioning: boolean;
  isVoiceMode: boolean;
  status: ConversationStatus;
}

const getStatusLabel = ({
  isConnected,
  isSpeaking,
  isTransitioning,
  isVoiceMode,
  status,
}: IGetConversationUiState) => {
  if (isTransitioning || status === 'disconnected') {
    return strings.aiCompanionConnecting;
  }

  if (status === 'error') {
    return strings.aiCompanionConnectionError;
  }

  if (isVoiceMode && isSpeaking) {
    return strings.aiCompanionSpeaking;
  }

  if (isVoiceMode) {
    return strings.aiCompanionListening;
  }

  if (isConnected) {
    return strings.aiCompanionConnected;
  }

  return strings.aiCompanionReady;
};

export const getConversationUiState = (
  state: IGetConversationUiState,
): ConversationUiState => {
  const {
    isConnected,
    isSpeaking,
    isTransitioning,
    status,
  } = state;
  let emptyStateDescription = strings.aiCompanionConnecting;
  let inputPlaceholder = strings.typeYourMessage;
  let voiceStatusLabel = isConnected
    ? strings.microphoneActive
    : strings.aiCompanionConnecting;

  if (isTransitioning || status === 'disconnected') {
    emptyStateDescription = strings.aiCompanionConnecting;
    inputPlaceholder = strings.aiCompanionConnecting;
    voiceStatusLabel = strings.aiCompanionConnecting;
  } else if (status === 'error') {
    voiceStatusLabel = strings.aiCompanionConnectionError;
  } else if (isSpeaking) {
    voiceStatusLabel = strings.aiCompanionSpeaking;
  } else if (isConnected) {
    emptyStateDescription = strings.typeOrUseVoice;
  }

  return {
    emptyStateDescription,
    inputPlaceholder,
    statusLabel: getStatusLabel(state),
    voiceActionLabel: strings.startVoiceConversation,
    voiceStatusLabel,
  };
};
